module.exports = __webpack_public_path__ + "PTMETTAabout-5.390a2e3c.png";